/**
 * @generated SignedSource<<a50275dedc181bf19edbf7bb14e67540>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityGroupSizeSelect_department$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useDepartmentGolfFacilitiesGroupSize_department">;
  readonly " $fragmentType": "DepartmentAvailabilityGroupSizeSelect_department";
};
export type DepartmentAvailabilityGroupSizeSelect_department$key = {
  readonly " $data"?: DepartmentAvailabilityGroupSizeSelect_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityGroupSizeSelect_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilityGroupSizeSelect_department",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDepartmentGolfFacilitiesGroupSize_department"
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "156b71970e7891901fcc1aa3b463b6c6";

export default node;
